import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { formatGigPrice, safeDateFormat } from 'utils/helpers';
import styles from 'styles/components/gigs/GigDetails.module.scss';

const JobDetail = ({ gig, hasPayment = true }) => {
  const currentUser = useSelector(state => state.auth.currentUser);
  const gigOwner = currentUser.id === gig.user.id;
  const label = gigOwner ? 'Budget' : "Buyer's budget";

  return (
    <div className={styles.info}>
      {!gig.public && <h3 className={styles.heading}>Gig detail</h3>}

      {hasPayment && (
        <div className={styles.row}>
          {formatGigPrice(gig, gigOwner ? gig.budget : gig.amount, label)}
        </div>
      )}

      <div className={styles.row}>
        Created: <span>{safeDateFormat(new Date(gig.created_at), 'MM.dd.yy')}</span>
      </div>

      {gig.status === 'active' ? (
        <div className={styles.row}>
          Full order delivered by:{' '}
          <span>{safeDateFormat(new Date(gig.delivery_by), 'MMMM dd, yyyy')}</span>
        </div>
      ) : (
        gig.expires_at && (
          <div className={styles.row}>
            Expires: <span>{safeDateFormat(new Date(gig.expires_at), 'MMMM dd, yyyy')}</span>
          </div>
        )
      )}

      <div className={styles.row}>
        Reference: <span>#{gig.id}</span>
      </div>
    </div>
  );
};

JobDetail.propTypes = {
  gig: PropTypes.object.isRequired,
};

export default JobDetail;
